import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Group, Title } from "@mantine/core";
const ResellerBillingsTableFilters = ({ total }) => {
    const { t } = useTranslation();
    return (_jsx(Group, { justify: "space-between", children: _jsx(Group, { gap: "sm", children: _jsxs(Title, { order: 1, size: "h6", tt: "uppercase", fw: "bolder", children: [t('My.customers_'), " (", total, ")"] }) }) }));
};
export default ResellerBillingsTableFilters;
